export default "__VITE_ASSET__BFgA37cJ__"